import { createAsyncThunk } from "@reduxjs/toolkit";
import apiAxios from "../../../services/apiAxios";
import {
    setPrescriptions,
    setLastCreatedPrescription,
    setPrescriptionLoading,
    setPrescriptionError,
    setRecentPrescriptions,
    setCurrentPrescription,
} from "../../Reducer/Prescription/PrescriptionSlice";
import toast from "react-hot-toast";

export const createPrescription = createAsyncThunk(
    "prescription/createPrescription",
    async (prescriptionData, { dispatch }) => {
        dispatch(setPrescriptionLoading(true));
        try {
            const response = await apiAxios.post("/api/prescription/create", prescriptionData);
            if (response.status === 201) {
                dispatch(setLastCreatedPrescription(response.data.prescription));
                dispatch(fetchRecentPrescriptions({ DID: prescriptionData.DID }));
                toast.success(response.data.message);
            }
            dispatch(setPrescriptionLoading(false));
            return response;
        } catch (error) {
            const message = error.response?.data?.error || error.message;
            toast.error(message);
            dispatch(setPrescriptionError(message));
            dispatch(setPrescriptionLoading(false));
            return error;
        }
    }
);

export const fetchPrescriptions = createAsyncThunk(
    "prescription/fetchPrescriptions",
    async ({ DID, page = 1, limit = 5, search = "" }, { dispatch }) => {
        try {
            const params = new URLSearchParams({ DID, page, limit });
            if (search) params.append("search", search);
            const response = await apiAxios.get(`/api/prescription/list?${params.toString()}`);
            if (response?.data) {
                dispatch(setPrescriptions(response.data));
            }
            return response?.data;
        } catch (error) {
            dispatch(setPrescriptionError(error.toString()));
            return error;
        }
    }
);

export const fetchRecentPrescriptions = createAsyncThunk(
    "prescription/fetchRecentPrescriptions",
    async ({ DID }, { dispatch }) => {
        try {
            const response = await apiAxios.get(`/api/prescription/recent?DID=${DID}`);
            if (response?.data?.prescriptions) {
                dispatch(setRecentPrescriptions(response.data.prescriptions));
            }
            return response?.data;
        } catch (error) {
            console.error("Error fetching recent prescriptions:", error);
            return error;
        }
    }
);

export const fetchPrescriptionByXID = createAsyncThunk(
    "prescription/fetchPrescriptionByXID",
    async ({ xid }, { dispatch }) => {
        try {
            const response = await apiAxios.get(`/api/prescription/xid/${xid}`);
            if (response?.data?.prescription) {
                dispatch(setCurrentPrescription(response.data.prescription));
            }
            return response?.data;
        } catch (error) {
            const message = error.response?.data?.error || error.message;
            toast.error(message);
            dispatch(setPrescriptionError(message));
            return error;
        }
    }
);

export const updatePrescription = createAsyncThunk(
    "prescription/updatePrescription",
    async ({ xid, data }, { dispatch }) => {
        dispatch(setPrescriptionLoading(true));
        try {
            const response = await apiAxios.put(`/api/prescription/${xid}`, data);
            if (response?.data?.prescription) {
                dispatch(setCurrentPrescription(response.data.prescription));
                toast.success(response.data.message);
            }
            dispatch(setPrescriptionLoading(false));
            return response;
        } catch (error) {
            const message = error.response?.data?.error || error.message;
            toast.error(message);
            dispatch(setPrescriptionError(message));
            dispatch(setPrescriptionLoading(false));
            return error;
        }
    }
);

export const sharePrescriptionOnWhatsapp = createAsyncThunk(
    "prescription/sharePrescription",
    async (shareData, { dispatch }) => {
        dispatch(setPrescriptionLoading(true));
        try {
            const response = await apiAxios.post("/api/prescription/share", shareData);
            if (response.status === 200) {
                toast.success("Prescription shared on WhatsApp successfully");
            }
            dispatch(setPrescriptionLoading(false));
            return response;
        } catch (error) {
            const message = error.response?.data?.error || error.message;
            toast.error(message);
            dispatch(setPrescriptionError(message));
            dispatch(setPrescriptionLoading(false));
            return error;
        }
    }
);

export const fetchOrdersByXID = createAsyncThunk(
    "prescription/fetchOrdersByXID",
    async ({ xid }, { dispatch }) => {
        try {
            const response = await apiAxios.get(`/api/prescription/orders/${xid}`);
            return response?.data;
        } catch (error) {
            console.error("Error fetching orders by XID:", error);
            return { orders: [] };
        }
    }
);

